module.exports = __webpack_public_path__ + "img/jj2.4e30519d.png";